export default __webpack_public_path__ + "static/media/boyds-rational-coefficient-tooltip.c79b136b.png";